import { render, staticRenderFns } from "./contractRuleForm.vue?vue&type=template&id=67f95488&scoped=true&"
import script from "./contractRuleForm.vue?vue&type=script&lang=js&"
export * from "./contractRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f95488",
  null
  
)

export default component.exports